const routes = [
    {
        path: "/scholarshiptypes",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "scholarshiptype_index"
        }
    }
];

export default routes;